var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRightBlue = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0A3887",
  d: "M19.707 8.707a1 1 0 0 0 0-1.414L13.343.929a1 1 0 1 0-1.414 1.414L17.586 8l-5.657 5.657a1 1 0 0 0 1.414 1.414zM0 9h19V7H0z"
})));
export { SvgArrowRightBlue as ReactComponent };
export default __webpack_public_path__ + "64cda57e393b286f2972a4b58ccc9b88.svg";